<template>
   <el-dialog title="合并" :visible.sync="viewVisible" :close-on-click-modal="false" @close="close">
    <el-form :model="mergeForm" :rules="rules" ref="ruleForm" :disabled="isReadOnly" :label-width="formLabelWidth">
      <el-form-item label="节点名称" prop="name">
        <el-input v-model="mergeForm.name" autocomplete="off" :maxlength="20"></el-input>
        <span class="nameTips" style="color:#627085">{{getNameLength}}/20</span>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="viewVisible = false">取 消</el-button>
      <el-button type="primary" :disabled="isReadOnly" @click="mergeSubmit">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
//合并
import mnode from "@/api/intelligentMarket/a_node";
export default {
  name: 'mergeDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    nodeId: Number,
    marketingId: Number,
   'isReadOnly': {
      type: Boolean,
      default: false
    }
  },
  components:{
  },
  created() {
    //双击节点，调取接口，获取节点输入框的名字    
    mnode.getNode({nodeId: this.nodeId}).then(res => {
      if (res.code === 1 && res.data.name) {
        this.mergeForm.name = res.data.name
      }
    })
  },
  computed:{
   viewVisible: {
      get: function () {
        return this.visible
      },
      set: function (newValue) {
        if (newValue) {
          this.$emit('update:visible', true)
        } else {
          this.$emit('update:visible', false)
        }
      }
    },
    getNameLength: function () {
      return this.mergeForm.name.length
    }
  },
  data () {
    return {
      formLabelWidth: '80px',
      rules: {
        name: [
          { required: true, message: '请输入节点名称', trigger: 'blur' },
          { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
        ]
      },
      mergeForm: {
        name: ''
      }
    }
  },
  methods:{
    //确定
    mergeSubmit(){
      this.$refs.ruleForm.validate((valid)=>{
        if(valid){
           let data = this.getDataify();
           mnode.updateDetail(data).then(res=>{
              this.$message.success(res.message);
              this.viewVisible = false;
              this.$emit('change-name', data);
           })
        }
      })
    },
    //获取数据
    getDataify(){
      let formData = {}
      formData.nodeId = this.$props.nodeId;
      formData.name = this.mergeForm.name;
      return formData
    },
    //关闭
    close(){
      this.viewVisible = false;
    }
  },
 }
</script>

<style>
</style>